import i18n from '@/core/i18n';
import { displayToastInfo } from '@/helpers/display-toast';

import usePlannerStore from '../index';
import { FilterCascadeKind } from '../types';

const CASCADE_TOAST_I18N_KEYS: Record<FilterCascadeKind, string> = {
  availability: 'authenticated.planner:toasts.availabilityFilterCleared',
  probability: 'authenticated.planner:toasts.probabilityFilterCleared',
};

/**
 * Shows the "filter was cleared" info toast when a filter cascade fires
 * (filterCascadeNotice set by setFilters). Lives OUTSIDE the store because
 * state stores don't speak i18n — mounted once by usePlannerStoreEffects.
 */
export const subscribeFilterCascadeToasts = (): (() => void) =>
  usePlannerStore.subscribe((state, prevState) => {
    const notice = state.filterCascadeNotice;
    if (!notice || notice === prevState.filterCascadeNotice) return;

    displayToastInfo(i18n.t(CASCADE_TOAST_I18N_KEYS[notice.kind]));
  });
